import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from "@angular/common";
import { NgModule } from '@angular/core';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { SidebarModule } from 'ng-sidebar';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { AutocompleteLibModule} from 'angular-ng-autocomplete';
import { HttpClientModule, HTTP_INTERCEPTORS} from "@angular/common/http";
import { ToastrModule } from 'ngx-toastr';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgxTextExpanderModule } from 'ngx-text-expander';
import { AngularDropdownModule } from 'angular-dropdown';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgStepperModule } from 'angular-ng-stepper';
import { NgxLoadingModule,ngxLoadingAnimationTypes  } from 'ngx-loading';
import { NgxImageZoomModule } from 'ngx-image-zoom';


import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { LoginAdminComponent } from './pagina-admin/login-admin/login-admin.component';
import { DashboardComponent } from './pagina-admin/dashboard/dashboard/dashboard.component';

//add angular material core
import { NgMaterialMultilevelMenuModule, MultilevelMenuService  } from 'ng-material-multilevel-menu';
import { NgxImgModule } from 'ngx-img';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';

import {MatMenuModule} from '@angular/material/menu';

//administracion gestion

import { ConfirmarComponent } from './comunes/confirmar/confirmar.component';
import { ConfirmarsionoComponent } from './comunes/confirmarsiono/confirmarsiono.component';
import { GestionUsuarioComponent } from './pagina-admin/dashboard/gestion-usuario/gestion-usuario.component';
import { GestionPlantillaComponent } from './pagina-admin/dashboard/gestion-plantilla/gestion-plantilla.component';
import { GestionConstanciaComponent } from './pagina-admin/dashboard/gestion-constancia/gestion-constancia.component';
import { DmlConstanciaComponent } from './pagina-admin/dashboard/gestion-constancia/dml-constancia/dml-constancia.component';
import { DmlUsuarioComponent } from './pagina-admin/dashboard/gestion-usuario/dml-usuario/dml-usuario.component';
import { DmlPlantillaComponent } from './pagina-admin/dashboard/gestion-plantilla/dml-plantilla/dml-plantilla.component';
import { DatosPersonalesComponent } from './pagina-admin/dashboard/gestion-usuario/datos-personales/datos-personales.component';
import { DmlParticipanteComponent } from './pagina-admin/dashboard/gestion-participante/dml-participante/dml-participante.component';
import { DmlParticipanteAVComponent } from './pagina-admin/dashboard/gestion-participante/dml-participante-av/dml-participante-av.component';
import { DmlEnvioFirmaComponent } from './pagina-admin/dashboard/gestion-participante/dml-envio-firma/dml-envio-firma.component';
import { AddFirmanteComponent } from './pagina-admin/dashboard/gestion-constancia/dml-constancia/add-firmante/add-firmante.component';
import { DmlVisorDocumentoComponent } from './pagina-admin/dashboard/gestion-participante/dml-visor-documento/dml-visor-documento.component';
import { GestionParticipanteComponent } from './pagina-admin/dashboard/gestion-participante/gestion-participante.component';
import { GestionConstanciaFirmaComponent } from './pagina-admin/dashboard/gestion-constancia-firma/gestion-constancia-firma.component';
import { GestionParticipanteFirmaComponent } from './pagina-admin/dashboard/gestion-participante-firma/gestion-participante-firma.component';
import { DmlFirmaComponent } from './pagina-admin/dashboard/gestion-participante-firma/dml-firma/dml-firma.component';
import { DmlFirmadoComponent } from './pagina-admin/dashboard/gestion-participante-firma/dml-firmado/dml-firmado.component';
import { DmlFirmaMensajeComponent } from './pagina-admin/dashboard/gestion-participante-firma/dml-firma-mensaje/dml-firma-mensaje.component';
import { ReporteEmitidosComponent } from './pagina-admin/dashboard/reporte/reporte-emitidos.component';
import { ReporteTotalAlumnosComponent } from './pagina-admin/dashboard/reporte/reporte-total-alumnos.component';
import { GestionCorreoComponent } from './pagina-admin/dashboard/gestion-correo/gestion-correo.component';
import { CorreoPruebaComponent } from './pagina-admin/dashboard/gestion-correo/correo-prueba/correo-prueba.component';
import { ResumenComponent } from './pagina-admin/dashboard/resumen/resumen.component';
import { VerificarComponent } from './pagina-admin/verificar/verificar.component';
import { DmlCargarCsvComponent } from './pagina-admin/dashboard/gestion-participante/dml-cargar-csv/dml-cargar-csv.component';

import { AngularEditorModule } from '@kolkov/angular-editor';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { RequestTimeoutHttpInterceptor, DEFAULT_TIMEOUT } from './service/timeout.interceptor.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginAdminComponent,
    DashboardComponent,
    ConfirmarComponent,
    ConfirmarsionoComponent,
    GestionUsuarioComponent, DmlUsuarioComponent, DatosPersonalesComponent,AddFirmanteComponent,
    GestionPlantillaComponent,DmlPlantillaComponent,GestionConstanciaComponent, DmlConstanciaComponent,
    GestionParticipanteComponent,DmlParticipanteAVComponent,DmlParticipanteComponent,DmlEnvioFirmaComponent,DmlVisorDocumentoComponent,
    GestionConstanciaFirmaComponent,GestionParticipanteFirmaComponent,DmlFirmaComponent,DmlFirmadoComponent,DmlFirmaMensajeComponent,
    ReporteEmitidosComponent,ReporteTotalAlumnosComponent,ResumenComponent,VerificarComponent,GestionCorreoComponent,CorreoPruebaComponent,
    DmlCargarCsvComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    NgbPaginationModule,
    AppRoutingModule,
    CdkStepperModule,
    NgStepperModule,
    NgxTextExpanderModule,
    AccordionModule.forRoot(),
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(),
    SidebarModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    SlickCarouselModule,
    AutocompleteLibModule,
    HttpClientModule,
    AngularEditorModule,
    MDBBootstrapModule.forRoot(),
    AngularDropdownModule,
    MatMenuModule,
    NgxLoadingModule.forRoot({ animationType: ngxLoadingAnimationTypes.wanderingCubes,fullScreenBackdrop:true,
  backdropBackgroundColour: 'rgba(0,0,0,0.3)',
  backdropBorderRadius: '4px',
  primaryColour: '#ffffff',
  secondaryColour: '#cccccc',
  tertiaryColour: '#bbbbbb'}),
    NgxImageZoomModule,
    NgxImgModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
    NgMaterialMultilevelMenuModule, // angular menu
    PdfViewerModule
  ],
  providers: [
    MultilevelMenuService,
    {provide : LocationStrategy,useClass: HashLocationStrategy},
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
